import { AnalyticsBrowser } from '@segment/analytics-next'
import { removeNullFields, removeFieldsOfTypes } from './lib';
import * as clevertap from './clevertap.js'

export const start = (window, segmentKey, clevertapAccountId, nodeEnv) => {
	const segmentEnabled = segmentKey && segmentKey.trim() !== ""
	const clevertapEnabled = clevertapAccountId && clevertapAccountId.trim() !== ""

	const segment = segmentEnabled ? AnalyticsBrowser.load({ writeKey: segmentKey }) : {}

	if (clevertapEnabled) {
		let clevertapLogMode = clevertap.CLEVERTAP_LOG_MODE_ALL

		if (nodeEnv === "production") {
			clevertapLogMode = clevertap.CLEVERTAP_LOG_MODE_ERRORS_ONLY
		}

		clevertap.init(clevertapAccountId, clevertapLogMode)
	}

	return {
		window,
		segmentEnabled,
		clevertapEnabled,
		segment,
	}
}

const prepareParamsForClevertap = (params) =>
	removeFieldsOfTypes(removeNullFields(params), [ "object", "undefined" ])

export const pageView = async (analyticsInstance, pageCode, params) => {
	if (analyticsInstance.segmentEnabled) {
		await analyticsInstance.segment.pageView(analyticsInstance.window.location.pathname)
	}

	if (analyticsInstance.clevertapEnabled) {
		clevertap.trackPageView(pageCode, prepareParamsForClevertap(params))
	}
}

export const trackEvent = async (analyticsInstance, eventName, eventParams) => {
	if (analyticsInstance.segmentEnabled) {
		await analyticsInstance.segment.track(eventName, eventParams)
	}

	if (analyticsInstance.clevertapEnabled) {
		clevertap.trackEvent(eventName, prepareParamsForClevertap(eventParams))
	}
}
